import React from "react";
import "./About.css";

const About = () => {
  return (
    <div className="about-page">
      <div className="about-layout">

        {/* ================= LEFT CONTENT ================= */}
        <main className="about-main">

          {/* HERO */}
          <section className="about-hero">
            <div className="about-hero-image">
              <img
                src="../images/About.webp"
                alt="Prof. (Dr.) Mallick"
              />
            </div>

            <div className="about-hero-text">
              <h1>Prof. (Dr) Mallick</h1>
              <h3>Healthcare Strategist • Neurodiversity Advocate • Technology Leader</h3>

              <p>
                Prof. (Dr) Mallick, formally known as Prof. (Dr) Mallikarjuna Rao
                Dubisetty, is a globally recognised healthcare strategist,
                neurodiversity advocate, and technology leader with over 28 years of
                experience across healthcare, technology, academia, and global
                consulting. His professional journey bridges clinical expertise,
                healthcare innovation, enterprise architecture, and social advocacy,
                positioning him as a thought leader at the intersection of healthcare,
                digital transformation, and inclusive development.
              </p>

              <p>
                His work focuses on advancing neurodevelopmental care,
                early-intervention frameworks, and inclusive healthcare ecosystems.
                Through research, policy advocacy, and technology innovation,
                Prof. Mallick continues to influence how organisations and
                healthcare systems globally approach autism, neurodiversity,
                and cross-disability rehabilitation.
              </p>
            </div>
          </section>


          {/* PROFESSIONAL PROFILE */}
          <section className="about-section">
            <h2>Professional Profile</h2>

            <p>
              Prof. Mallick serves in multiple global leadership roles including
              Vice President for Healthcare and Life Sciences Strategy and Execution
              at HelixBeat LLC and Chairman of the Kyndryl India True Ability
              Initiative (KIN 2025). He is also recognised as an Academic Ambassador
              and Global University Relations leader supporting interdisciplinary
              collaboration across academic institutions, research organisations,
              and healthcare innovation ecosystems.
            </p>

            <p>
              A certified Special Educator in Autism Spectrum Disorder and a
              specialist in Child Development and Early Intervention across
              cross-disabilities and neurodevelopmental disorders, he combines
              clinical expertise with technology-driven healthcare solutions.
              His background includes leadership positions at IBM, Kyndryl,
              Accenture, Apollo Hospitals, NIIT, and NISC, where he worked on
              enterprise healthcare architecture, digital health systems,
              regulatory compliance, and healthcare transformation strategies.
            </p>

            <p>
              Prof. Mallick is also an IBM Gold Certified Healthcare Insights
              and Solutions Architect and a recognised global strategist in
              healthcare analytics, cybersecurity in health systems, and
              AI-driven healthcare platforms.
            </p>
          </section>


          {/* PERSONAL JOURNEY */}
          <section className="about-section">
            <h2>Personal Journey & Inspiration</h2>

            <p>
              A deeply personal motivation drives Prof. Mallick’s work.
              As the parent of a child with autism, he embarked on a lifelong
              journey to better understand neurodevelopmental disorders,
              inclusive education, and early intervention methodologies.
              Over the past two decades, he has conducted extensive
              independent research in autism and neurodevelopmental care,
              translating lived experiences into evidence-based frameworks
              that benefit families, clinicians, educators, and policymakers.
            </p>

            <p>
              This personal commitment has inspired his global advocacy
              efforts and the establishment of international platforms that
              support children with autism and neurodiverse individuals
              worldwide.
            </p>
          </section>


          {/* FOUNDATIONS */}
          <section className="about-section">
            <h2>Global Advocacy & Foundations</h2>

            <p>
              Prof. Mallick is the Founder of Smiles Foundation India and
              the World Autism Society, organisations dedicated to
              supporting individuals with autism and neurodevelopmental
              challenges through awareness, research, training, and
              community programs. These initiatives aim to create integrated
              support systems for families, clinicians, educators, and
              policymakers working in the field of neurodevelopmental care.
            </p>

            <p>
              Through these platforms he has collaborated with professionals
              and institutions across more than sixty countries to expand
              global awareness of autism and neurodiversity while promoting
              inclusive healthcare policies and educational frameworks.
            </p>
          </section>


          {/* RESEARCH */}
          <section className="about-section">
            <h2>Research & Academic Contributions</h2>

            <p>
              Prof. Mallick is currently pursuing doctoral research focusing on
              True Ability Challenges and Human Resource Management,
              examining how organisations can build inclusive workplaces
              that empower persons with disabilities and neurodiverse
              professionals. His research integrates healthcare sciences,
              organisational leadership, and social inclusion frameworks.
            </p>

            <p>
              His academic background includes an MBA in Hospital and Health
              Systems Management from BITS Pilani and CMC Vellore, a
              postgraduate qualification in Early Intervention and
              Neurodevelopmental Disorders from Osmania University and
              the Rehabilitation Council of India, and a Bachelor of Education
              in Special Education for Autism Spectrum Disorder.
            </p>

            <p>
              In addition, he holds an MBA in Telecommunication Management
              specialising in tele-health and tele-medicine, along with multiple
              professional certifications in healthcare technology,
              neurodevelopmental assessment, and clinical rehabilitation
              compliance.
            </p>
          </section>


          {/* SPEAKING */}
          <section className="about-section">
            <h2>Global Speaking Engagements</h2>

            <p>
              Prof. Mallick is an internationally invited speaker who regularly
              addresses global forums and academic conferences on topics
              including neurodiversity, digital healthcare transformation,
              artificial intelligence in medicine, and early intervention
              strategies.
            </p>

            <p>
              His presentations have been featured at TEDx, the International
              Patient Safety Conference, Mobile World Congress in Barcelona,
              MEDInfo Taiwan, NABIDH Elevate Dubai, and the National
              Healthcare Conference. Through these engagements he
              continues to influence international conversations around
              inclusive healthcare innovation and responsible technology
              adoption.
            </p>
          </section>


          {/* PUBLICATIONS */}
          <section className="about-section">
            <h2>Publications & Thought Leadership</h2>

            <p>
              Prof. Mallick is the author of numerous thought leadership
              articles, research papers, and publications addressing
              neurodevelopmental care, healthcare technology, and
              organisational leadership. His work includes peer-reviewed
              research in international journals as well as industry insights
              published across healthcare and technology platforms.
            </p>

            <p>
              He has also authored a book describing his real-life journey
              as the parent of a child with autism, sharing experiences,
              case studies, and practical insights to support families and
              caregivers navigating similar challenges.
            </p>

            <p>
              His professional blogs and knowledge platforms include
              SameStory.in and AutismHelp.in, where he publishes
              educational content, research insights, and advocacy
              perspectives for global audiences.
            </p>
          </section>


          {/* AWARDS */}
          <section className="about-section">
            <h2>Awards & Recognition</h2>

            <p>
              Prof. Mallick has received numerous international recognitions
              for his contributions to neurodevelopmental research,
              inclusive healthcare advocacy, and technology-enabled
              healthcare innovation. He has been honoured with
              Changemaker and CSR Gold awards for his impact in
              advancing autism care and neurodiversity inclusion.
            </p>

            <p>
              His work has also been recognised by academic institutions,
              professional organisations, and the Government of Telangana
              for contributions to autism research and caregiving initiatives.
            </p>
          </section>


          {/* VISION */}
          <section className="about-section">
            <h2>Vision for the Future</h2>

            <p>
              Prof. Mallick envisions a future where healthcare systems,
              technology platforms, and social institutions work together
              to create truly inclusive environments for individuals with
              neurodevelopmental conditions.
            </p>

            <p>
              By combining artificial intelligence, digital health
              ecosystems, ethical governance frameworks, and
              multidisciplinary clinical expertise, he aims to advance
              a global movement that empowers neurodiverse individuals
              while ensuring that innovation in healthcare remains
              compassionate, responsible, and human-centred.
            </p>
          </section>

        </main>


        {/* ================= RIGHT SIDEBAR ================= */}
        <aside className="about-videos">

          <h3 className="video-title">Featured Talks</h3>

          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/qu-1imPrqIE"
              title="World Autism Day"
              loading="lazy"
              allowFullScreen
            />
            <p>World Autism Day</p>
          </div>

          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/ZRX2C7oi8iA"
              title="National Health Conference"
              loading="lazy"
              allowFullScreen
            />
            <p>National Health Conference</p>
          </div>

          <div className="video-card">
            <iframe
              src="https://www.youtube.com/embed/6Sqnb1zCEf4"
              title="Natural Wellness Methods"
              loading="lazy"
              allowFullScreen
            />
            <p>Natural Wellness Methods</p>
          </div>

        </aside>

      </div>
    </div>
  );
};

export default About;
